var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DisplayOnce } from "@tk-events/fw";
import React from "react";
import { getUserData } from "../../../config/common";
import algosec from "../booths/algosec";
import bluevoyant from "../booths/bluevoyant";
import { textModal } from "../booths/common";
import crowdstrike from "../booths/crowdstrike";
import cybelangel from "../booths/cybelangel";
import huawei from "../booths/huawei";
import ibm from "../booths/ibm";
import kpmg from "../booths/kpmg";
import reliaquest from "../booths/reliaquest";
import securityscorecard from "../booths/securityscorecard";
import surecloud from "../booths/surecloud";
export var BoothThree = {
    body: {
        userData: getUserData(),
        background: "https://assets.swoogo.com/uploads/full/2187919-636d17597c32b.jpg",
        name: "Room Three",
        links: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], reliaquest, true), crowdstrike, true), cybelangel, true), algosec, true), securityscorecard, true), surecloud, true), bluevoyant, true), [
            {
                width: "16.3%",
                height: "7%",
                left: "24.1%",
                top: "90%",
                label: "Room Two",
                href: "/Room-Two"
            },
            {
                width: "17.6%",
                height: "7%",
                left: "41.1%",
                top: "90%",
                label: "Exibition Hall",
                href: "/Exibition-Hall"
            },
            {
                width: "16%",
                height: "7%",
                left: "59.6%",
                top: "90%",
                label: "Room One",
                href: "/Room-One"
            }
        ], false)
    },
    location: "/Room-Three"
};
export var BoothTwo = {
    body: {
        userData: getUserData(),
        background: "https://assets.swoogo.com/uploads/full/2182029-636a704ec06fc.jpg",
        name: "Room Two",
        extras: React.createElement(DisplayOnce, __assign({ id: "ibm-booth-4" }, textModal("30%")),
            React.createElement("p", null, "When you interact with IBM, this serves as your authorisation to The ISF to provide your contact information to IBM in order for IBM to follow up on your interaction."),
            React.createElement("p", null,
                "IBM\u2019s use of your contact information is governed by the ",
                React.createElement("a", { style: { textDecoration: "underline" }, href: "http://ibm.com/us-en/privacy" }, "IBM Privacy Policy"))),
        links: __spreadArray(__spreadArray(__spreadArray([], huawei, true), ibm, true), [
            {
                width: "16.3%",
                height: "7%",
                left: "24.1%",
                top: "90%",
                label: "Room One",
                href: "/Room-One"
            },
            {
                width: "17.6%",
                height: "7%",
                left: "41.1%",
                top: "90%",
                label: "Exibition Hall",
                href: "/Exibition-Hall"
            },
            {
                width: "16%",
                height: "7%",
                left: "59.6%",
                top: "90%",
                label: "Room Three",
                href: "/Room-Three"
            }
        ], false)
    },
    location: "/Room-Two"
};
export var BoothOne = {
    body: {
        userData: getUserData(),
        background: "https://assets.swoogo.com/uploads/full/2169901-6362905855ead.jpg",
        name: "Room One",
        links: __spreadArray(__spreadArray([], kpmg, true), [
            {
                width: "16.3%",
                height: "7%",
                left: "24.1%",
                top: "90%",
                label: "Room Three",
                href: "/Room-Three"
            },
            {
                width: "17.6%",
                height: "7%",
                left: "41.1%",
                top: "90%",
                label: "Exibition Hall",
                href: "/Exibition-Hall"
            },
            {
                width: "16%",
                height: "7%",
                left: "59.6%",
                top: "90%",
                label: "Room Two",
                href: "/Room-Two"
            }
        ], false)
    },
    location: "/Room-One"
};
